import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'check-input',
  templateUrl: './check-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckInputComponent),
      multi: true
    }
  ]
})
export class CheckInputComponent implements OnInit, ControlValueAccessor {

  // Attributes
  public disabled: boolean;

  @Input() public name: string;
  @Input() public value: any;
  @Input() public mode: 'switch' | false = false;
  @Input() public type: 'checkbox' | 'radio' = 'checkbox';
  @Input('disabled') set disabled$(value: boolean) {
    this.disabled = (typeof value !== 'string')
      ? value
      : this._elementRef.nativeElement.hasAttribute('disabled');

    this._cdr.detectChanges();
  }

  // Model
  public localeValue: any;

  private onTouched = () => {};
  private onChange: (value: string) => void = () => {};

  constructor(private _elementRef: ElementRef,
              private _cdr: ChangeDetectorRef) { }

  get isSwitch() {
    return this.mode === 'switch';
  }

  get isCheckbox() {
    return this.type === 'checkbox';
  }

  get isChecked() {
    return this.isCheckbox ? this.localeValue : this.localeValue === this.value;
  }

  ngOnInit() {
    this.localeValue = this.value
  }

  changeValue(e) {
    let value = this.isCheckbox ? e.target.checked : this.value;
    this.writeValue(value);
    this.onTouched();
  }

  writeValue(value: any) {
    this.localeValue = value;

    this.onChange(this.localeValue);

    this._cdr.detectChanges();
  }

  registerOnChange(onChange: (value: string) => void) {
    this.onChange = onChange;

    this._cdr.detectChanges();
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;

    this._cdr.detectChanges();
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;

    this._cdr.detectChanges();
  }
}
